import type { WeddingData } from "../types/wedding";

// REFERENCE DATA ONLY - DO NOT USE AS NEW CUSTOMER DEFAULT
export const referenceWeddingData: WeddingData = {
  project: {
    id: "reference-reky-stephanie",
    name: "Reky & Stephanie Wedding Invitation",
    slug: "reky-stephanie",
    status: "published",
    language: "id",
    timezone: "Asia/Jakarta",
    createdAt: "2026-05-17T00:00:00.000Z",
    updatedAt: "2026-08-02T00:00:00.000Z",
    publishedAt: "2026-06-01T00:00:00.000Z"
  },
  invitation: {
    guestName: "aa & partner",
    title: "Reky & Stephanie",
    subtitle: "Wedding Invitation",
    openingText: "Dengan penuh kebahagiaan, kami mengundang Anda untuk hadir di hari pernikahan kami.",
    closingText: "Kehadiran dan doa restu Anda akan menjadi bagian indah dari awal perjalanan baru kami sebagai keluarga.",
    coverImage: "/reference-assets/cover-closing.webp",
    coverVideo: "",
    openButtonText: "Click Here"
  },
  couple: {
    groom: {
      fullName: "Reky Huang",
      displayName: "Reky Huang",
      parents: "",
      instagram: "",
      photo: "/reference-assets/people/groom.webp"
    },
    bride: {
      fullName: "Stephanie Kenny Wonggo",
      displayName: "Stephanie Kenny Wonggo",
      parents: "",
      instagram: "",
      photo: "/reference-assets/people/bride.webp"
    }
  },
  story: {
    enabled: true,
    title: "Our Story",
    introduction: "From a simple hello, two hearts found their way to a promise that will last forever.",
    items: [
      {
        id: "story-2018",
        date: "2018",
        title: "Where It Began",
        description: "No one could have imagined that a simple meeting at a vocational school in Taiwan would become the beginning of something so beautiful. Reky was the senior, Stephanie was the junior, and between small glances, quiet moments, and ordinary days, a gentle feeling began to grow.",
        image: "",
        order: 0
      },
      {
        id: "story-instagram",
        date: "Instagram",
        title: "Little Conversations",
        description: "It started with Reky following Stephanie on Instagram. Messages became comfort, comfort became closeness, and closeness quietly became love.",
        image: "",
        order: 1
      },
      {
        id: "story-2019",
        date: "06 Jun 2019",
        title: "The Day We Chose Us",
        description: "After months of getting to know each other, they chose to begin this journey together. Their days were filled with simple happiness, laughter, and memories that still feel warm whenever they look back.",
        image: "",
        order: 2
      },
      {
        id: "story-2020",
        date: "2020",
        title: "Through Every Season",
        description: "When Reky started college, their time together became less frequent. In Kaohsiung, they learned that love is about continuing to choose each other through every season.",
        image: "",
        order: 3
      },
      {
        id: "story-2023",
        date: "Oct 2023",
        title: "A Promise for Forever",
        description: "In October 2023, Reky proposed to Stephanie. It became a promise, a new chapter, and the beginning of the future they dreamed of building side by side.",
        image: "",
        order: 4
      },
      {
        id: "story-2026",
        date: "2026",
        title: "To Our Wedding Day",
        description: "With hearts full of gratitude and joy, they are ready to step into forever and invite their loved ones to witness the beginning of their life as husband and wife.",
        image: "",
        order: 5
      }
    ]
  },
  events: [
    {
      id: "reception-bride",
      type: "reception-bride",
      title: "Reception Bride",
      date: "2026-11-18",
      startTime: "18:00",
      endTime: "",
      timezone: "Asia/Jakarta",
      venueName: "Gedung Sahabat Brahrang",
      address: "Jl. Anggur No.28, Padang Brahrang, Kec. Binjai Bar., Kota Binjai, Sumatera Utara 20719, Indonesia",
      mapsUrl: "https://maps.app.goo.gl/qb6UPYkAHNeifeVG8",
      additionalInformation: "",
      order: 0
    },
    {
      id: "tea-pai",
      type: "tea-pai",
      title: "Tea Pai Ceremony",
      date: "2026-11-25",
      startTime: "00:00",
      endTime: "",
      timezone: "Asia/Jakarta",
      venueName: "Grand Liberty Restaurant",
      address: "Jl. KL. Yos Sudarso No.A6, Silalas, Kec. Medan Bar., Kota Medan, Sumatera Utara 20234, Indonesia",
      mapsUrl: "https://www.google.com/maps/search/?api=1&query=Grand%20Liberty%20Restaurant%20Jl.%20KL.%20Yos%20Sudarso%20No.A6%20Medan",
      additionalInformation: "",
      order: 1
    },
    {
      id: "reception-day",
      type: "reception",
      title: "Reception Day",
      date: "2026-11-25",
      startTime: "00:00",
      endTime: "",
      timezone: "Asia/Jakarta",
      venueName: "Grand Liberty Restaurant",
      address: "Jl. KL. Yos Sudarso No.A6, Silalas, Kec. Medan Bar., Kota Medan, Sumatera Utara 20234, Indonesia",
      mapsUrl: "https://www.google.com/maps/search/?api=1&query=Grand%20Liberty%20Restaurant%20Jl.%20KL.%20Yos%20Sudarso%20No.A6%20Medan",
      additionalInformation: "",
      order: 2
    }
  ],
  countdown: {
    enabled: true,
    eventId: "reception-bride",
    targetDate: "2026-11-18T18:00:00+07:00"
  },
  gallery: {
    enabled: true,
    title: "Gallery",
    images: [
      ["gallery-01", "DSC09151.webp"], ["gallery-02", "DSC09072.webp"],
      ["gallery-03", "DSC07781.webp"], ["gallery-04", "DSC08076.webp"],
      ["gallery-05", "DSC07960.webp"], ["gallery-06", "DSC03267.webp"],
      ["gallery-07", "DSC09144.webp"], ["gallery-08", "DSC07634.webp"],
      ["gallery-09", "DSC07822.webp"], ["gallery-10", "DSC09098.webp"],
      ["gallery-11", "DSC08679.webp"], ["gallery-12", "DSC09195.webp"],
      ["gallery-13", "DSC08269.webp"], ["gallery-14", "DSC03737.webp"],
      ["gallery-15", "DSC07907.webp"], ["gallery-16", "DSC08291.webp"],
      ["gallery-17", "DSC09157.webp"], ["gallery-18", "DSC03747.webp"],
      ["gallery-19", "DSC07863.webp"], ["gallery-20", "DSC09094-new.webp"],
      ["gallery-21", "DSC08289.webp"], ["gallery-22", "DSC08593.webp"],
      ["gallery-23", "DSC09094.webp"], ["gallery-24", "DSC07830.webp"]
    ].map(([id, file], order) => ({
      id,
      url: `/reference-assets/gallery/${file}`,
      alt: `Wedding gallery photo ${order + 1}`,
      caption: "",
      order
    }))
  },
  music: {
    enabled: true,
    url: "/reference-assets/audio/wedding-song.mp3",
    title: "You're Still The One",
    artist: "Shania Twain",
    autoplayAfterInteraction: true,
    loop: true,
    volume: 0.5
  },
  rsvp: {
    enabled: true,
    title: "RSVP",
    description: "Kami sangat menantikan kehadiran Anda. Mohon bantu kami menyiapkan hari bahagia ini dengan mengisi reservasi terlebih dahulu.",
    deadline: "2026-11-10",
    maximumGuests: 10,
    attendanceOptions: ["Hadir", "Tidak hadir"]
  },
  gifts: {
    enabled: true,
    title: "Doa restu Anda adalah hadiah terbaik bagi kami.",
    description: "Bagi keluarga dan sahabat yang ingin mengirimkan tanda kasih, silakan buka halaman hadiah untuk memilih rekening tujuan.",
    backgroundImage: "/reference-assets/gift-background.webp",
    bankAccounts: [
      {
        id: "bca-reference",
        bankName: "BCA",
        accountNumber: "0223168121",
        accountHolder: "Rekyhuang",
        bankLogo: "/template-assets/banks/bca-logo.svg",
        order: 0,
        enabled: true
      },
      {
        id: "ocbc-reference",
        bankName: "OCBC",
        accountNumber: "693814612554",
        accountHolder: "Stephanie Kenny Wonggo",
        bankLogo: "/template-assets/banks/ocbc-logo.svg",
        order: 1,
        enabled: true
      }
    ],
    qrCodes: []
  },
  liveStreaming: {
    enabled: false,
    title: "Watch Our Wedding Live",
    description: "Untuk keluarga dan sahabat yang tidak dapat hadir langsung, silakan menyaksikan momen bahagia kami melalui live streaming.",
    url: "",
    thumbnail: "",
    startDate: ""
  },
  wishes: {
    enabled: true,
    title: "Wishes for Us",
    description: "Tinggalkan doa dan pesan hangat. Pesan akan tampil di halaman ini agar bisa dibaca bersama.",
    emojiOptions: ["❤️", "💕", "✨", "🌸", "🙏", "🥂", "💍", "😊"],
    moderationEnabled: true
  },
  barcode: {
    enabled: false,
    title: "Invitation Barcode",
    description: "Show this barcode at reception.",
    image: ""
  },
  closing: {
    image: "/reference-assets/cover-closing.webp",
    title: "",
    message: "Our hearts will be even happier with your presence.\n\nThank you for your love, blessings, and warm wishes.\n\nWe look forward to celebrating with you.",
    signature: "Reky & Stephanie"
  },
  navigation: {
    enabled: true,
    items: [
      { id: "nav-detail", label: "Detail", target: "events", order: 0 },
      { id: "nav-story", label: "Story", target: "story", order: 1 },
      { id: "nav-gallery", label: "Gallery", target: "gallery", order: 2 },
      { id: "nav-rsvp", label: "RSVP", target: "rsvp", order: 3 },
      { id: "nav-gift", label: "Gift", target: "gift", order: 4 }
    ]
  },
  theme: {
    primaryColor: "#314334",
    secondaryColor: "#7a8b72",
    accentColor: "#b68566",
    backgroundColor: "#f7f3eb",
    textColor: "#1c1b19",
    headingFont: "Georgia, 'Times New Roman', serif",
    bodyFont: "Inter, ui-sans-serif, system-ui, sans-serif",
    sectionSpacing: "clamp(72px, 10vw, 140px)",
    animationStyle: "warm"
  },
  layout: { elements: {} },
  sections: [
    ["cover", 0], ["couple", 1], ["story", 2], ["countdown", 3],
    ["events", 4], ["rsvp", 5], ["gallery", 6], ["gift", 7],
    ["liveStreaming", 8], ["wishes", 9], ["closing", 10]
  ].map(([type, order]) => ({
    id: `section-${type}`,
    type: type as WeddingData["sections"][number]["type"],
    enabled: type === "liveStreaming" ? false : true,
    order: order as number,
    settings: type === "cover"
      ? { heroImage: "/reference-assets/hero.webp", mobileHeroImage: "/reference-assets/hero-mobile.webp" }
      : type === "couple"
        ? { introBackground: "/reference-assets/intro-background.webp" }
        : type === "events"
          ? { photoBreak: "/reference-assets/photo-break.webp" }
          : type === "wishes"
            ? { youtubeUrl: "https://youtu.be/-xK8JizNa1w", youtubeThumbnail: "/reference-assets/video-thumbnail.webp" }
            : {}
  })),
  seo: {
    title: "Reky & Stephanie Wedding Invitation",
    description: "Undangan pernikahan Reky Huang dan Stephanie Kenny Wonggo, 18 dan 25 November 2026.",
    ogImage: "/reference-assets/cover-closing.webp",
    favicon: "/reference-assets/favicon.png",
    noIndex: false
  }
};
